import request from '@/utils/request'
export const Download = '/icps/system/sign/settlement/raw/rawStatementDetail/exportList'
export const Download2 = '/icps/system/sign/settlement/raw/rawStatementDetail/exportListTwo'
/**1.分页获取已结算数据*/
export const queryPage1 = '/icps/system/sign/settlement/raw/rawStatementDetail/get_settled_consignment'
/**2.获取未结算数据*/
export const queryPage2 = '/icps/system/sign/settlement/raw/rawStatementDetail/get_no_settlement_consignment'
/**3.获取原物料合同列表*/
export function get_contract_list(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/get_contract_list',
    method: 'get',
    params: data
  })
}
/**4.合同id获取原物料列表*/
export function get_raw_list(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/get_raw_list',
    method: 'get',
    params: data
  })
}
/**5.生成结算单详情*/
export function generate_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/generate_statement_detail',
    method: 'POST',
    data
  })
}
/**6.保存结算单详情(仅生成结算单时*/
export function save_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/save_statement_detail',
    method: 'POST',
    data,
    timeout:60000
  })
}
/**7.根据站点名获取站点id*/
export function get_station_list(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/get_station_list',
    method: 'POST',
    data
  })
}
/**8.根据结算单编号获取结算单详情*/
export function get_statement_detail(params) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/get_statement_detail',
    method: 'get',
    params
  })
}
/**9.修改结算单*/
export function update_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/update_statement_detail',
    method: 'POST',
    data
  })
}
/**10.获取补差*/
export function generate_statement_compensate(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/Compensate/generate_statement_compensate',
    method: 'POST',
    data
  })
}

/**11.分页查询结算单*/
export const queryPage3 = '/icps/system/sign/settlement/raw/rawStatement/get_raw_statement_page'
/**12.跟新审核状态*/
export function update_audit_status(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatement/update_audit_status',
    method: 'POST',
    data
  })
}
/**13.修改供应商确认状态*/
export function update_supplier_confirm(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatement/update_supplier_confirm',
    method: 'POST',
    data
  })
}
/**14.获取已结算查询条件*/
export function get_query_condition(params) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatementDetail/get_query_condition',
    method: 'get',
    params
  })
}
/**15.获取结算单查询条件-供应商*/
export function get_supplier(params) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatement/get_supplier	',
    method: 'get',
    params,
  })
}
/**16.结算单发给供应商*/
export function send_to_supplier(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/rawStatement/send_to_supplier',
    method: 'post',
    data
  })
}